module.exports = __webpack_public_path__ + "static/virtual-reality-san-diego-stem-festival-735bf868e4ac571c445cf4ab646b3671.jpg";